import { useLang } from '../i18n'

const CONTACT_EMAIL = 'contact@ubigym.ma'
const color = '#10b981'

export default function Hero() {
  const { t } = useLang()
  const h = t.hero

  return (
    <section style={{ minHeight: '100vh', background: '#0a0a0a', display: 'flex', alignItems: 'center', position: 'relative', overflow: 'hidden', paddingTop: 64 }}>
      <div style={{ position: 'absolute', inset: 0, background: `radial-gradient(ellipse at 50% 40%, ${color}14 0%, transparent 65%)`, pointerEvents: 'none' }} />

      <div style={{ maxWidth: 900, margin: '0 auto', padding: '100px 24px 80px', textAlign: 'center', position: 'relative' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: `${color}18`, border: `1px solid ${color}30`, borderRadius: 999, padding: '6px 16px', marginBottom: 28 }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: color, display: 'inline-block' }} />
          <span style={{ color, fontSize: 12, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase' }}>{h.badge}</span>
        </div>

        <h1 style={{ color: 'white', fontSize: 'clamp(2.6rem,6vw,4.5rem)', fontWeight: 900, lineHeight: 1.05, margin: '0 0 24px', letterSpacing: '-1.5px' }}>
          {h.title1}<br />
          <span style={{ color }}>{h.title2}</span>
        </h1>

        <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 'clamp(16px,2vw,20px)', lineHeight: 1.7, margin: '0 auto 44px', maxWidth: 580 }}>
          {h.desc}
        </p>

        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href={`mailto:${CONTACT_EMAIL}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '15px 32px', borderRadius: 10, background: color, color: 'white', fontWeight: 700, fontSize: 16, textDecoration: 'none', boxShadow: `0 0 40px ${color}30` }}>
            {h.cta}
          </a>
          <a href="#how" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '15px 28px', borderRadius: 10, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.8)', fontWeight: 600, fontSize: 16, textDecoration: 'none' }}>
            {h.ctaSub}
          </a>
        </div>

        <p style={{ color: 'rgba(255,255,255,0.2)', fontSize: 13, marginTop: 20 }}>{h.fine}</p>
      </div>
    </section>
  )
}
